import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-primary-700 via-primary-800 to-primary-950 text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold uppercase tracking-wider rounded-full bg-accent-500/20 text-accent-200 border border-accent-500/30">
            / About Us /
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight max-w-2xl">
            Your Trusted Source for{' '}
            <span className="text-accent-300">Superbuy Sheet</span> Knowledge
          </h2>
          <p className="mt-4 text-white/60 text-base leading-relaxed max-w-xl">
            We are a dedicated research team passionate about helping shoppers discover products faster and smarter through organized resources and expert guidance.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20fashion%20mood%20boards%20pinned%20on%20cork%20wall%20laptop%20showing%20product%20spreadsheets%20fresh%20coffee%20cup%20and%20small%20potted%20plant%20on%20warm%20oak%20desk%20soft%20natural%20daylight%20creative%20studio%20atmosphere%20editorial%20lifestyle%20photography&width=700&height=700&seq=about-brand-2026-v3&orientation=squarish"
              alt="Superbuy Sheet research and discovery"
              className="w-full rounded-xl"
            />
          </div>

          <div>
            <div className="font-heading text-7xl md:text-8xl font-bold text-accent-300 leading-none">
              400+
            </div>
            <p className="mt-2 text-white/70 text-sm leading-relaxed">
              Curated product resources and guides
            </p>

            <div className="mt-8 space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-accent-400 mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-white text-sm">Research-Driven Content</h4>
                  <p className="mt-1 text-white/50 text-sm">Every guide is thoroughly researched, reviewed and updated regularly to provide accurate and useful Superbuy Sheet information.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-accent-400 mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-white text-sm">Updated Weekly</h4>
                  <p className="mt-1 text-white/50 text-sm">Our category databases and product lists are refreshed weekly to ensure you always have access to the latest finds and trends.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-accent-400 mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-white text-sm">Beginner Friendly</h4>
                  <p className="mt-1 text-white/50 text-sm">Whether you are a seasoned shopper or just getting started, our resources are designed to be accessible and easy to navigate for everyone.</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <Link
                to="/article/superbuy-sheet-complete-guide"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 text-sm font-semibold rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More About Us
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}